import { Route } from "react-router-dom";

export const generatePrivateRoutes = (routes) => {
  return routes.map((route) => {
    const { children, import: importPath, ...rest } = route;

    if (children) {
      return <Route {...rest}>{generatePrivateRoutes(children)}</Route>;
    }
    if (!importPath) return <Route {...route} />;
    return <Route {...route} lazy={() => import(`../../../${importPath}`)} />;
  });
};
